// removed by extract-text-webpack-plugin
module.exports = {"decorate":"_3-RL","topBorder":"_3eOO","mr":"_1LXy","ml":"OpUv","view":"_3P1e","l":"DwXN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/decorate/index.less
// module id = 251
// module chunks = 0